import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { PlatformLocation } from "@angular/common";
import { ListInfo } from "./list/shared/list-info";
import { ViewStateService } from "../../../shared/services/view-state.service";
import { UserService } from "../../../shared/services/user.service";
import {
  ActiveDirectorySearchItem,
  PageDataItem,
} from "../models/activeSearch";
import { DirectoryService } from "./../../shared/services/directory.service";
import { BehaviorSubject, Subject } from "rxjs";
import { SearchParameters } from "./../../shared/models/search-parameters";
import moment from "moment";
import { filter, takeUntil, tap } from "rxjs/operators";

@Component({
  selector: "app-directory",
  templateUrl: "./directory.component.html",
})
export class DirectoryComponent implements OnInit, OnDestroy {
  @Input() showAllPractitioners: boolean;

  listInfo: ListInfo;
  isPractitionerActive: boolean;
  welcome:boolean =true;

  private _searchParams: SearchParameters;
  searchParams$ = new BehaviorSubject<SearchParameters>(null);
  private destroy$ = new Subject<void>();

  constructor(
    private directoryService: DirectoryService,
    private viewState: ViewStateService,
    private userService: UserService,
    private platformLocation: PlatformLocation
  ) {
    this.listInfo = new ListInfo([], null, 10, 1);
    this._searchParams = new SearchParameters();
  }

  ngOnInit() {
    this.isPractitionerActive = !this.userService.isCurrentUserInactive;

    this.searchParams$
      .pipe(
        tap(() => this.listInfo.setPageNumber(1)),
        filter((x) => x != null),
        takeUntil(this.destroy$)
      )
      .subscribe((value) => this.onSearchSuccess(value));
  }

  onSearchSuccess(result) {
    this.viewState.startLoading();
    if (result.clear == "true") {
      this.listInfo.pageData.splice(0, this.listInfo.totalRecords);
      this.listInfo.totalRecords = 0;
      this.viewState.stopLoading();
    } else {
      this._searchParams = result;
      this.handleFormResult(this.listInfo.pageNumber);
    }
  }

  pageClicked(newPageNumber) {
    this.handleFormResult(newPageNumber);
  }

  private handleFormResult(displayPageNumber: number) {
    this.viewState.startLoading();

    const offset = (displayPageNumber - 1) * this.listInfo.pageLimit;

    const directorySearch$ = this.showAllPractitioners
      ? this.directoryService.getAllDirectorySearch(
          offset,
          this.listInfo.pageLimit,
          this._searchParams.firstName,
          this._searchParams.lastName,
          this._searchParams.birthdate,
          this._searchParams.credential,
          this._searchParams.city,
          this._searchParams.state
        )
      : this.directoryService.getActiveDirectorySearch(
          offset,
          this.listInfo.pageLimit,
          this._searchParams.firstName,
          this._searchParams.lastName,
          this._searchParams.birthdate,
          this._searchParams.credential,
          this._searchParams.city,
          this._searchParams.state
        );

    directorySearch$.pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.listInfo.totalRecords = res.totalCount;
        this.setListInfoPageData(res.items);
        this.viewState.stopLoading();
      },
      (e) => {
        this.viewState.stopLoading();
      }
    );
  }

  private setListInfoPageData(items: ActiveDirectorySearchItem[]) {
    let pageDataArray: PageDataItem[] = [];
    items.forEach((item, index) => {
      let pageDataItem: PageDataItem = {
        activeDirectoryItem: item,
        id: index,
        showAddress: false,
      };
      item.certifications.map(
        (c) =>
          (c["isExpired"] =
            c.expirationDate && moment(c.expirationDate) < moment(new Date())
              ? true
              : false)
      );
      pageDataArray.push(pageDataItem);
    });
    this.listInfo.pageData = pageDataArray;
  }

  public getLoginPath() {
    let href = (this.platformLocation as any).hostname + "/auth";
    //console.log(href)
    return href;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
